import type {ReactAction} from '@netx/core/bootstrap';
import {dispatcher} from '@netx/core-next/instance/dispatcher';
import {faUnlock} from '@fortawesome/pro-solid-svg-icons';
import {canUnlockAsset} from '../enablers';
import {AssetActionLabel} from '../locales';
import {type IAsset} from '../schema';
import {ASSET_EVENT} from './constants';

export const assetActionUnlockIcon = faUnlock;

/**
 * Unlock asset
 * @param params
 * @returns Action
 */
export const assetActionUnlock = (
	asset?: IAsset,
	params?: Partial<ReactAction>,
): ReactAction => ({
	name: 'asset-unlock',
	cb: () => dispatcher.trigger(ASSET_EVENT.UNLOCK, asset),
	enableTest: () => canUnlockAsset(asset),
	icon: assetActionUnlockIcon,
	get label() {
		return AssetActionLabel.UNLOCK;
	},
	...params,
});

export default assetActionUnlock;
